import React from "react";
import styles from "./Table.module.sass";
import Loader from "../../../components/Loader";
import Row from "./Row";
import Empty from "../../../components/Empty";
import { Pager } from "../../../components/Pager";
import Icon from "../../../components/Icon";
import { useUser } from "../../../context";
import collection from "../../../i11/Collection";

const Table = ({
	items,
	isLoading,
	set_edit,
	getCollection_,
	setFilter,
	filter,
	...rest
}) => {
	const { locale } = useUser();
	const sort = (name) => {
		setFilter((p) => {
			return {
				...p,
				order_by: name,
				order_direction:
					p.order_by === name
						? p.order_direction === "ASC"
							? "DESC"
							: "ASC"
						: "DESC",
			};
		});
	};
	return (
		<div className={styles.wrapper}>
			<div className={styles.table}>
				<div className={styles.row}>
					<div className={styles.col} onClick={() => sort("name")}>
						{collection[locale].name}
						{filter.order_by === "name" && (
							<Icon
								className={styles.icon_}
								name={
									filter.order_direction === "ASC"
										? "arrow-top"
										: "arrow-bottom"
								}
								size="12"
							/>
						)}
					</div>
					<div className={styles.col}>
						{collection[locale].product}
					</div>
					<div className={styles.col}></div>
				</div>
				{items.map((x) => (
					<Row
						getCollection_={getCollection_}
						item={x}
						key={x._id}
						set_edit={set_edit}
					/>
				))}
			</div>
			{!isLoading && items.length === 0 && <Empty />}
			{isLoading && <Loader className={styles.loader} />}
			<div className={styles.foot}>
				<Pager {...rest} />
			</div>
		</div>
	);
};

export default Table;
